import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import { useBudouX } from "@/hooks/useBudouX";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import Pager from "@/components/organisms/Pagination";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export async function getStaticPaths() {
  const pageListApiUrl =
    "https://ab1ue7gpa0.microcms.io/api/v1/news?filters=newslisthideflg[equals]true[and]detailflg[equals]true";
  const headers = {
    "X-MICROCMS-API-KEY": process.env.X_MICROCMS_API_KEY,
  };
  const response = await fetch(pageListApiUrl, { headers: headers });
  const json = await response.json();

  let paths = [];
  (json?.contents || []).map((content) => {
    paths.push({ params: { pageId: content.id } });
  });

  return {
    fallback: false,
    paths: paths,
  };
}

export async function getStaticProps(context) {
  const headers = {
    "X-MICROCMS-API-KEY": process.env.X_MICROCMS_API_KEY,
  };

  // ニュースの取得
  const pageId = context.params.pageId;
  const pageApiUrl = "https://ab1ue7gpa0.microcms.io/api/v1/news/" + pageId;

  const pageResponse = await fetch(pageApiUrl, { headers: headers });
  const pageJson = await pageResponse.json();

  return {
    props: {
      page: pageJson ? pageJson : {},
    },
  };
}

export default function NewsArticle(props) {
  const page = props.page;
  const isHeaderRelative = true;
  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={page.title}
        pageDescription={
          "株式会社トッカシステムズの" +
          page.title +
          "です。" +
          "日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/page/" + page.id}
        noIndex={page.noindexflg}
      />
      <Layout className="bg-gray-50">
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="pt-6 pb-12 md:pt-8 md:pb-20">
              <BreadCrumb
                lists={[
                  {
                    name: "TOP",
                    path: "/",
                  },
                  {
                    name: page.title,
                  },
                ]}
              />
              <div className="bg-white py-6 md:mt-6 md:py-10 lg:py-20">
                {/* <div
                  className="
                    mx-auto
                    mb-8
                    max-w-4xl
                    space-y-6
                    border-x-0
                    border-t-0
                    border-b
                    border-solid
                    border-bdc-light
                    px-8
                    pb-6
                    md:space-y-8
                    lg:px-0
                  "
                >
                  <p className="text-sm font-bold text-txt-light">
                    {" "}
                    {dayjs.utc(page.date).tz("Asia/Tokyo").format("YYYY.MM.DD")}
                  </p>
                  <h3 className="text-2xl font-bold text-txt-base">
                    {page.title}
                  </h3>
                </div> */}
                <div
                  className="mx-auto max-w-4xl px-8 text-md text-txt-base lg:px-0"
                  dangerouslySetInnerHTML={{
                    __html: page.content,
                  }}
                ></div>
              </div>
              <Pager Top />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
